// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"71ed61b7","238":"0b11a19c","644":"4116562a","732":"31e83934","865":"91c03927"}[chunkId] + ".chunk.js";
};